const API = process.env.API ?? 'https://izylab-api.metaoptics.vision';

const PHOTO_SENDING_REQUEST = process.env.PHOTO_SENDING_REQUEST ?? 'api/Photo';
const PHOTO_RETRIEVAL_REQUEST = process.env.PHOTO_RETRIEVAL_REQUEST ?? 'api/Photo';

export { API, PHOTO_SENDING_REQUEST, PHOTO_RETRIEVAL_REQUEST };
